import { useTranslation } from 'react-i18next';

import { useForumSavedPosts } from '~/api/forum/useForumSavedPosts';

import { ForumPosts } from '../components/ForumPosts';

export const ForumSavedPosts = () => {
  const query = useForumSavedPosts();

  const { t } = useTranslation(['forum']);

  return (
    <ForumPosts
      emptyMessage={t('forum:overview.savedPosts.empty')}
      errorMessage={t('forum:overview.savedPosts.error.title')}
      page="savedPosts"
      query={query}
    />
  );
};
